import {Endpoint} from '@eryxcoop/appyx-comm';

export default class LeadPipelineEndpoint extends Endpoint {
    adaptValues(leadPipelineFilters) {
        return {
            fantasy_name: leadPipelineFilters.fantasyName,
            responsible_email: leadPipelineFilters.responsibleEmail,
            how_they_knew_us: leadPipelineFilters.howTheyKnewUs,
            commercial_channel: leadPipelineFilters.commercialChannel,
            pipeline_age: leadPipelineFilters.pipelineAge,
        };
    }
}
